import type { KnowledgeItem } from '@/types';

// 阳极振压成型车间知识库（18 条）
// 涵盖：工艺基础 / 5 大典型缺陷 / 参数与质量关系 / 设备维护 / 安全
export const anodeKnowledge: KnowledgeItem[] = [
  // ============ 工艺基础 ============
  {
    id: 'AN-K001',
    tags: ['阳极', '工艺', '基础'],
    question: '预焙阳极生产的 4 道主要工序是什么？',
    answer: '①煅烧（石油焦 1250°C 煅烧脱挥发分）→ ②配料混捏（焦粉+沥青 165°C 混捏 30 分钟）→ ③振压成型（1280 t 振压 95 s 出生阳极）→ ④焙烧（1100°C 焙烧 25 天熟化）。',
  },
  {
    id: 'AN-K002',
    tags: ['配方', '工艺', '基础'],
    question: '阳极典型配方是什么比例？',
    answer: '常规配方：石油焦粗粒 28~32% + 中粒 25~30% + 细粒 33~37% + 粘结剂沥青 14~16 wt%。沥青多则流动性好但强度低，沥青少则振压困难易开裂。',
  },
  {
    id: 'AN-K003',
    tags: ['糊料温度', '工艺', '关键参数'],
    question: '糊料温度为什么必须维持 145~155°C？',
    answer: '沥青在 145~155°C 粘度 8000~12000 mPa·s 流动性最佳。< 140°C 沥青硬化，振压时颗粒间结合差，开裂；> 165°C 沥青裂解，气体多导致起鼓。',
  },
  {
    id: 'AN-K004',
    tags: ['模具温度', '工艺', '关键参数'],
    question: '模具温度调多少最合适？',
    answer: '130~145°C 区间最佳。< 110°C 糊料骤冷开裂/缺角；> 160°C 糊料粘模脱模困难。冷开机要预热到 130°C 才能开始生产。',
  },
  {
    id: 'AN-K005',
    tags: ['真空度', '工艺', '关键参数'],
    question: '真空度为什么要 ≤ 5 kPa？',
    answer: '真空抽气是为了排出糊料中的空气和挥发分。绝压 > 5 kPa 时气体困在糊料内部，振压后气泡膨胀导致顶部起鼓和内部气孔，密度下降。',
  },

  // ============ 5 大典型缺陷 ============
  {
    id: 'AN-K101',
    tags: ['缺陷', '裂纹', '故障'],
    question: '生阳极表面裂纹的根本原因？',
    answer: '主因：糊料温度过低（< 140°C）导致沥青硬化、颗粒结合差。次因：模具温度低 + 振压压力过大。处方：糊料温度升到 150°C + 模具预热 135°C。',
  },
  {
    id: 'AN-K102',
    tags: ['缺陷', '起鼓', '故障'],
    question: '阳极顶部起鼓怎么处理？',
    answer: '起鼓 = 内部气体困住。先查真空泵：绝压打到 3 kPa 以下 + 抽气流量 ≥ 200 m³/h；再延振压时间到 110 s 给气体充分排出时间。',
  },
  {
    id: 'AN-K103',
    tags: ['缺陷', '缺角', '故障'],
    question: '阳极棱角缺料的处理流程？',
    answer: '主因模具温度过低（< 110°C）导致棱角处糊料冻结脆裂。提加热功率到 70 kW + 模具预热到 135°C + 喷脱模剂均匀，缺角问题立即缓解。',
  },
  {
    id: 'AN-K104',
    tags: ['缺陷', '密度', '故障'],
    question: '生阳极密度偏低（< 1.55 g/cm³）怎么办？',
    answer: '振实不充分。三步骤同时操作：振压时间提到 100 s + 压力提到 1300 t + 振动频率 50 Hz。密度跟成品电阻率直接相关，必须管控。',
  },
  {
    id: 'AN-K105',
    tags: ['缺陷', '粘模', '故障'],
    question: '阳极粘模脱模困难怎么处理？',
    answer: '通常是模具温度过高（> 160°C）+ 脱模剂用量不足。立即降模温到 140°C + 喷涂脱模剂量 ×1.5。强行顶出可能顶碎阳极，慎用。',
  },

  // ============ 参数与质量关系 ============
  {
    id: 'AN-K201',
    tags: ['密度', '质量', '工艺'],
    question: '生阳极密度多少算合格？',
    answer: '生阳极密度（振实密度）正常 1.58~1.65 g/cm³。焙烧后熟阳极密度应达 1.52~1.58 g/cm³，体积密度越高，电阻率越低（约 50~60 μΩ·m），耗电越省。',
  },
  {
    id: 'AN-K202',
    tags: ['振压时间', '密度', '工艺'],
    question: '振压时间和密度什么关系？',
    answer: '振压时间 ↑ → 颗粒重排越充分 → 密度 ↑，但边际效益递减。90~110 s 为最经济区间。> 120 s 没有显著提升反而拖产能；< 80 s 密度明显不足。',
  },
  {
    id: 'AN-K203',
    tags: ['沥青', '配方', '工艺'],
    question: '沥青含量越多越好吗？',
    answer: '不是。沥青多（> 17%）流动性虽好但焙烧时收缩大开裂多，抗折强度下降。沥青少（< 13%）颗粒结合差，密度低。14.5~15.5% 是 sweet spot。',
  },
  {
    id: 'AN-K204',
    tags: ['抗折强度', '质量', '工艺'],
    question: '熟阳极的抗折强度应达多少？',
    answer: '电解槽用阳极抗折强度应 ≥ 8 MPa（GB/T 8742）。强度低易在装炉/电解过程中开裂掉块，污染电解质。强度由密度 + 粘结剂均匀性 + 焙烧曲线共同决定。',
  },
  {
    id: 'AN-K205',
    tags: ['电阻率', '质量', '工艺'],
    question: '阳极电阻率有什么要求？',
    answer: '熟阳极电阻率 50~60 μΩ·m。电阻率每高 5 μΩ·m，电解槽吨铝多耗 100~150 kWh。所以振压成型阶段对密度的管控直接影响下游电解车间的能耗。',
  },

  // ============ 设备与安全 ============
  {
    id: 'AN-K301',
    tags: ['设备', '维护', '振压机'],
    question: '振压机日常维护重点是什么？',
    answer: '①液压系统：每班查油位 + 每周清滤芯 + 每年换油。②模具：每 50 块巡检表面，发现划痕立即修磨。③振动器：每月检查偏心轮平衡。',
  },
  {
    id: 'AN-K302',
    tags: ['安全', '高温', '操作'],
    question: '车间高温作业有哪些防护？',
    answer: '糊料 160°C + 模具 140°C + 生阳极 220°C 都是高温。戴隔热手套 + 防溅护目镜 + 长袖工服。沥青蒸气有 PAH 致癌物，戴口罩 + 排风必须开。',
  },
  {
    id: 'AN-K303',
    tags: ['质量', '检验', 'QC'],
    question: '生阳极出厂前要做哪些检验？',
    answer: '①外观目视（无裂纹/起鼓/缺角）②尺寸测量（长宽高 ±2 mm）③重量复称（1080±15 kg）④密度抽样（1.58~1.65 g/cm³）⑤每班抽 2 块送实验室做抗折强度。',
  },
];
